import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import imgBarchart from "assets/images/icons/barchart.svg";
import Maybe from "./Maybe";
import ContentLoading from "./ContentLoading";


const DashboardBox = (props) => {
    return (
        <div onClick={props.onClick} className={"p-4 box flex justify-between space-x-3 " + (props.onClick && "cursor-pointer")}>

            <div className="">
                <div className="text-sm text-[#757575]">
                    {props.title}
                </div>
                <div className="mt-2 text-black text-xl font-bold">
                    <Maybe condition={props.loading}>
                        <FontAwesomeIcon icon="circle-notch" spin />
                    </Maybe>
                    <Maybe condition={!props.loading}>
                        {props.value}
                    </Maybe>
                </div>
                <Maybe condition={props.subtext !== undefined}>
                    <div className="mt-4 text-sm text-[#33B843] font-medium">
                        {props.subtext}
                    </div>
                </Maybe>
            </div>

            {/* 
            <Maybe condition={props.icon !== undefined}>
                <div className="w-10 h-10 xl:w-12 xl:h-12 flex-shrink-0 rounded-xl flex items-center justify-end">
                    {props.icon}
                </div>
            </Maybe>
            
            <Maybe condition={props.icon === undefined && props.useDefaultIcon === true}>
                <div className="w-10 h-10 xl:w-12 xl:h-12 flex-shrink-0 rounded-xl flex items-center justify-end">
                    <img src={imgBarchart} alt={props.title} className="w-9 h-9 object-contain" />
                </div>
            </Maybe>
             */}
            
            <Maybe condition={props.rightContent !== undefined}>
                {props.rightContent}
            </Maybe>

        </div>
    )
}


export const DashboardBox2 = (props) => {
    return (
        <div onClick={props.onClick} style={props.parentStyle || {}} className={"p-4 box shadow-sm"  + (props.onClick && "cursor-pointer")}>
            <Maybe condition={props.icon !== undefined}>
                {props.icon}
            </Maybe>
            
            <div className="mt-4 text-sm text-[#1A202C] tracking-wider">
                {props.title}
            </div>
            
            <div className="text-2xl font-bold">
                <ContentLoading
                    loading={props.loading}
                    data={props.value}
                />
            </div>
            
            <Maybe condition={props.subtext !== undefined}>
                <div className="mt-1 text-xs text-gray-500">
                    {props.subtext}
                </div>
            </Maybe>
        </div>
    )
}


export default DashboardBox
